'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 加载资源
 */
var LoadResources = function () {
  function LoadResources() {
    (0, _classCallCheck3.default)(this, LoadResources);

    this.LOAD_SCRIPT_EVENT = null; // 参照单例模式，只允许存在一个实例
  }

  (0, _createClass3.default)(LoadResources, [{
    key: 'loadJS',
    value: function loadJS(name, path) {
      if (!path) {
        console.error('加载资源路径必填。');
        return;
      }
      if (!window[name]) {
        if (this.LOAD_SCRIPT_EVENT) {
          return this.LOAD_SCRIPT_EVENT;
        } else {
          var script = document.createElement('script');
          script.defer = true;
          script.src = path;
          document.body.appendChild(script);
          this.LOAD_SCRIPT_EVENT = script;
          return script;
        }
      }
      return null;
    }
  }]);
  return LoadResources;
}();

exports.default = new LoadResources();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/common/load.js
// module id = 260
// module chunks = 0